module.exports = __webpack_public_path__ + "static/img/udm.c03b3fcf.png";